import { render, staticRenderFns } from "./Anotacoes.vue?vue&type=template&id=14f98ffe&"
import script from "./Anotacoes.vue?vue&type=script&lang=js&"
export * from "./Anotacoes.vue?vue&type=script&lang=js&"
import style0 from "./Anotacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports